<template>
  <span
    class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-blue-100 text-blue-700"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "InfoBadge",
  props: ["label"],
};
</script>
